import React from "react";
import { Box, Typography, Skeleton } from "@mui/material";

import { StatCardProps } from "../../types/interface";
import "./statCard.css";

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  bgColor,
  color,
  loading = false,
  trend, // optional (e.g. +12%)
}) => {
  // 🔥 number formatting
  const formatValue = (val: number | string) => {
    if (typeof val === "number") {
      return val.toLocaleString("en-IN");
    }
    return val;
  };

  return (
    <Box className="stat-card">
      
      {/* 🔥 ICON */}
      <Box
        className="stat-icon"
        style={{ backgroundColor: bgColor, color: color }}
      >
        {icon}
      </Box>

      {/* 🔥 CONTENT */}
      <Box className="stat-content">

        {/* VALUE */}
        {loading ? (
          <Skeleton width={60} height={30} />
        ) : (
          <Typography className="stat-value">
            {formatValue(value)}
          </Typography>
        )}

        {/* TITLE */}
        {loading ? (
          <Skeleton width={80} height={20} />
        ) : (
          <Typography className="stat-title">
            {title}
          </Typography>
        )}

        {/* 🔥 TREND (OPTIONAL) */}
        {!loading && trend && (
          <Typography
            sx={{
              fontSize: "12px",
              mt: 0.5,
              color: trend.startsWith("-")
                ? "var(--danger)"
                : "var(--success)",
            }}
          >
            {trend}
          </Typography>
        )}

      </Box>
    </Box>
  );
};

export default StatCard;